import theme from "./gatsby-plugin-theme-ui"
export default theme
